import * as React from 'react';
import { ExpandablePanel, ElementLoader, ComplexValue } from 'ui';
import { ItemTypes, FieldItem } from '../../../types';
import { dropPanelForItemType } from '../../../components/drop-panel';
import { dragPanelForItemType } from '../../../components/drag-panel';
import { ButtonSelectMultipleDialog } from '../../../components/button-select-multiple-dialog';
import { DropArea } from '../../../components/drop-area';
import styles from '../../dnd.scss';
import { DistributionState } from '../types-store';
import { DistributionField } from './distribution-field';
import { withCachedTranslation } from 'app/components/enhancers/with-cached-translation';
import { DistributionPanelTexts } from 'app/area/reports/containers/distribution/components/distribution-panel-texts';

const DistributionDropPanel = dropPanelForItemType(ItemTypes.DISTRIBUTION_FIELD);

const DistributionDragField = dragPanelForItemType(ItemTypes.DISTRIBUTION_FIELD);

export interface DistributionPanelProps {
  orderNumber: string;
  fetching: boolean;

  data: DistributionState;
  selectedExposureApplication: ComplexValue<number>;
  selectedExposureFactor: number;
  selectedExposurePercent: number;

  onLoadFields: () => void;
  onUpdateDefaultFields: (items: FieldItem[]) => void;
  onSelect: (exposureApplication: FieldItem, exposureFactor?: number, exposurePercent?: number, fetchDefaults?: boolean) => void;
  onUpdateField: (exposureApplication: FieldItem, exposureFactor?: number, exposurePercent?: number) => void;
  onRemove: () => void;
  translation: DistributionPanelTexts;
}

class DistributionPanelComponent extends React.PureComponent<DistributionPanelProps> {

  private handleOnSelect = (items: FieldItem[]) => {
    const defaultFields = this.props.data.defaultFields.map(f => f.value);
    const removedRedundandItems = items.filter(i => defaultFields.indexOf(i.value) === -1).map(i => ({added: true, ...i}));
    this.props.onUpdateDefaultFields([
      ...this.props.data.defaultFields,
      ...removedRedundandItems
    ]);
  };

  private onSelectField = (field: FieldItem) => {
    this.props.onSelect(field, undefined, undefined, true);
  };

  public renderContent() {
    const {
      data: {
        defaultFields = [],
        additionalFields = []
      },
      selectedExposureApplication,
      selectedExposureFactor,
      selectedExposurePercent,
      onLoadFields,
      translation
    } = this.props;

    const selectedFieldValue = selectedExposureApplication?.value;

    return <div className="row">
      <div className="col-6">
        <ul className={styles.dragTagContainer}>
          {defaultFields.map(item => {
            const isSelected = selectedFieldValue === item.value;
            return <DistributionDragField
              key={item.value}
              className={styles.dragTag}
              field={item}
              isSelected={isSelected}
              onSelect={this.onSelectField}
              onRemove={this.props.onRemove}
            />;
          })}
          <ButtonSelectMultipleDialog
            className={styles.dragTag}
            options={additionalFields}
            placeholder={translation.distribution_search}
            textButtonAdd={`+ ${translation.distribution_btn_open_dialog}`}
            textTitle={translation.distribution_dialog_title}
            textConfirm={translation.distribution_done}
            onLoadOptions={onLoadFields}
            onSelect={this.handleOnSelect}
          />
        </ul>
      </div>
      <div className="col-6">
        <DistributionDropPanel
          className={styles.dropBox}
          addItem={this.onSelectField}
        >
          {selectedExposureApplication?.value
            ? <DistributionField
              selectedExposureApplication={selectedExposureApplication}
              selectedExposureFactor={selectedExposureFactor}
              selectedExposurePercent={selectedExposurePercent}
              onUpdateField={this.props.onUpdateField}
              translation={this.props.translation}
            />
            : <DropArea text={translation.distribution_drag_n_drop} />
          }
        </DistributionDropPanel>
      </div>
    </div>;
  }
  public render(): JSX.Element {
    const {
      translation
    } = this.props;

    return <ExpandablePanel title={`${this.props.orderNumber}. ${translation.distribution_area_title}`}>
      {this.props.fetching
        ? <ElementLoader />
        : this.renderContent()}
    </ExpandablePanel>;
  }
}

export const DistributionPanel = withCachedTranslation<DistributionPanelProps>(DistributionPanelComponent);
